import React, { useState, useEffect } from 'react';
import './Kalkulator.css';
import { FiDollarSign } from 'react-icons/fi';

// 1. Definisanje gradova i stopa (Provjerite aktuelne stope za Vašu opštinu/grad)
const GRADOVI = [
  { ime: "Banja Luka", stopa: 13 },
  { ime: "Istočno Sarajevo", stopa: 13 },
  { ime: "Trebinje", stopa: 13 },
  { ime: "Doboj", stopa: 12 }, // Primjer, provjerite tačnu stopu
  { ime: "Prijedor", stopa: 10 },
  { ime: "Bijeljina", stopa: 11 },
  { ime: "Laktaši", stopa: 11 },
  { ime: "Gradiška", stopa: 11 },
  { ime: "Ručni unos", stopa: "manual" } // Specijalna opcija
];

function KalkulatorDoprinosiPorez() {
  const [unosTip, setUnosTip] = useState('bruto');
  const [bruto, setBruto] = useState('');
  const [neto, setNeto] = useState('');
  
  // NOVO: Stanja za porez
  const [selectedGrad, setSelectedGrad] = useState(GRADOVI[0].ime); // Default prvi grad
  const [manualPorezStopa, setManualPorezStopa] = useState(13.0);
  
  // Pomoćna funkcija da dobijemo trenutnu stopu
  const getTrenutnuStopu = () => {
    const grad = GRADOVI.find(g => g.ime === selectedGrad);
    if (grad && grad.stopa !== "manual") {
      return parseFloat(grad.stopa);
    }
    return parseFloat(manualPorezStopa);
  };

  const [errors, setErrors] = useState({ bruto: '', neto: '', porez: '' });
  const [rezultati, setRezultati] = useState(null);
  const [submitError, setSubmitError] = useState(null);

  const validateField = (name, value) => {
    let msg = '';
    if (value.trim() === '') {
      msg = 'Ovo polje je obavezno.';
    } else if (isNaN(Number(value)) || Number(value) < 0) {
      msg = 'Unesite nenegativan broj.';
    }
    setErrors(prev => ({ ...prev, [name]: msg }));
  };

  // Zajednička funkcija za fetch (da ne bismo ponavljali kod)
  const izvrsiIzracun = (payload) => {
    fetch('https://plata--kalkulator-backend-api--gklzkvjpw2s5.code.run/menadzerski/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(async (res) => {
        if (!res.ok) throw new Error('Greška pri izračunu.');
        const data = await res.json();
        setRezultati(data);
        setSubmitError(null);
      })
      .catch(err => {
        setRezultati(null);
        setSubmitError(err.message);
      });
  };

  // Bruto useEffect
  useEffect(() => {
    if (unosTip === 'bruto') {
      if (bruto.trim() !== '' && errors.bruto === '') {
        const payload = { 
            bruto: parseFloat(bruto.replace(',', '.')),
            porez_postotak: getTrenutnuStopu() // Šaljemo trenutnu stopu
        };
        izvrsiIzracun(payload);
      } else {
        setRezultati(null);
        setSubmitError(null);
      }
    }
  }, [bruto, errors.bruto, unosTip, selectedGrad, manualPorezStopa]); // Dodane zavisnosti za stopu

  // Neto useEffect
  useEffect(() => {
    if (unosTip === 'neto') {
      if (neto.trim() !== '' && errors.neto === '') {
        const payload = { 
            neto: parseFloat(neto.replace(',', '.')),
            porez_postotak: getTrenutnuStopu() // Šaljemo trenutnu stopu
        };
        izvrsiIzracun(payload);
      } else {
        setRezultati(null);
        setSubmitError(null);
      }
    }
  }, [neto, errors.neto, unosTip, selectedGrad, manualPorezStopa]); // Dodane zavisnosti za stopu

  const handleBrutoChange = (e) => {
    const v = e.target.value.replace(',', '.');
    setBruto(v);
    validateField('bruto', v);
  };

  const handleNetoChange = (e) => {
    const v = e.target.value.replace(',', '.');
    setNeto(v);
    validateField('neto', v);
  };

  const handleUnosTipChange = (e) => {
    setUnosTip(e.target.value);
    setBruto('');
    setNeto('');
    setErrors({ bruto: '', neto: '' });
    setRezultati(null);
    setSubmitError(null);
  };

  return (
    <>
      <header className="app-header">
        <h1>
          MENADŽERSKI UGOVOR <br />
          <br />
          (Obračun bez formalnog radnog odnosa)
        </h1>
      </header>

    <div className="container">
      <div className="form-container card">
        <div className="form-header">
          <h2>Unos podataka</h2>
        </div>

        {/* NOVO: Odabir stope poreza */}
        <div className="field-group">
            <label htmlFor="gradSelect" className="field-label">
                Lokacija (Stopa poreza)<span className="required">*</span>:
            </label>
            <select
                id="gradSelect"
                className="field-select"
                value={selectedGrad}
                onChange={(e) => setSelectedGrad(e.target.value)}
            >
                {GRADOVI.map((grad, index) => (
                    <option key={index} value={grad.ime}>
                        {grad.ime} {grad.stopa !== "manual" ? `(${grad.stopa}%)` : ''}
                    </option>
                ))}
            </select>
        </div>

        {selectedGrad === "Ručni unos" && (
            <div className="field-group">
                <label htmlFor="manualStopa" className="field-label">
                    Unesite stopu poreza (%)
                </label>
                <input
                    type="number"
                    id="manualStopa"
                    className="field-input"
                    value={manualPorezStopa}
                    onChange={(e) => setManualPorezStopa(e.target.value)}
                />
            </div>
        )}
        
        <br /> {/* Malo razmaka vizualno */}

        <div className="field-group">
          <label htmlFor="unosTip" className="field-label">
            Izaberite vrstu unosa<span className="required">*</span>:
          </label>
          <select
            id="unosTip"
            className="field-select"
            value={unosTip}
            onChange={handleUnosTipChange}
          >
            <option value="bruto">Bruto</option>
            <option value="neto">Neto</option>
          </select>
        </div>

        {unosTip === 'bruto' && (
          <div className="field-group">
            <label htmlFor="bruto" className="field-label">
              Bruto<span className="required">*</span>:
            </label>
            <input
              type="text"
              id="bruto"
              className={`field-input ${errors.bruto ? 'shake' : ''}`}
              placeholder="npr. 2000,00"
              value={bruto}
              onChange={handleBrutoChange}
              onBlur={(e) => validateField('bruto', e.target.value.replace(',', '.'))}
            />
            {errors.bruto && <div className="error-text">{errors.bruto}</div>}
          </div>
        )}

        {unosTip === 'neto' && (
          <div className="field-group">
            <label htmlFor="neto" className="field-label">
              Neto<span className="required">*</span>:
            </label>
            <input
              type="text"
              id="neto"
              className={`field-input ${errors.neto ? 'shake' : ''}`}
              placeholder="npr. 1200,00"
              value={neto}
              onChange={handleNetoChange}
              onBlur={(e) => validateField('neto', e.target.value.replace(',', '.'))}
            />
            {errors.neto && <div className="error-text">{errors.neto}</div>}
          </div>
        )}
      </div>

      <div className="results-container card">
        {rezultati && (
          <>
            <h3 className="section-title">Rezultati</h3>
            <div className="results-section">
              <div className="result-row">
                <span>Bruto:</span>
                <span>{rezultati.bruto.toFixed(2)} KM</span>
              </div>
              <div className="result-row">
                <span>Neto:</span>
                <span>{rezultati.neto.toFixed(2)} KM</span>
              </div>
              <div className="result-row">
                <span>PIO (18.5%):</span>
                <span>{rezultati.PIO.toFixed(2)} KM</span>
              </div>
              <div className="result-row">
                <span>Zdravstvo (10.2%):</span>
                <span>{rezultati.zdravstveno.toFixed(2)} KM</span>
              </div>
              <div className="result-row">
                <span>Djeca (1.7%):</span>
                <span>{rezultati.djeca.toFixed(2)} KM</span>
              </div>
              <div className="result-row">
                <span>Nezaposlenost (0.6%):</span>
                <span>{rezultati.nezaposlenost.toFixed(2)} KM</span>
              </div>
              <div className="result-row">
                <b><span>Doprinosi ukupno:</span></b>
                <b><span>{rezultati.doprinosi_ukupno.toFixed(2)} KM</span></b>
              </div>
              <div className="result-row">
                <span>Porez ({rezultati.porez_stopa}%):</span>
                <span>{rezultati.porez.toFixed(2)} KM</span>
              </div>
            </div>
          </>
        )}
        {submitError && <div className="error-text">{submitError}</div>}
      </div>
    </div>
    </>
  );
}

export default KalkulatorDoprinosiPorez;
